import {ChangeDetectionStrategy, Component, HostListener, ViewEncapsulation} from '@angular/core';
import {NavLayoutService} from '@app/services/nav-layout.service';
import {isSearchShortcut} from '../model/nav-layout';

/**
 * Ctrl/Cmd+K, anywhere: the side menu's own search box when it is open, otherwise this
 * dialog with the same search. Focus is trapped while it is open and returns where it was.
 */
@Component({
  selector: 'app-nav-command-palette',
  templateUrl: './nav-command-palette.component.html',
  styleUrls: ['./nav-command-palette.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NavCommandPaletteComponent {
  readonly open$ = this.navLayout.paletteOpen$;
  private returnFocus: HTMLElement | null = null;

  constructor(private navLayout: NavLayoutService) {
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    const modalOpen = !!document.querySelector('ngb-modal-window, .modal.show');
    if (!isSearchShortcut(event, modalOpen)) return;
    event.preventDefault();
    this.returnFocus = document.activeElement as HTMLElement;
    this.navLayout.requestSearch();
  }

  close(): void {
    this.navLayout.closePalette();
    const target = this.returnFocus;
    this.returnFocus = null;
    setTimeout(() => target?.focus?.());
  }

  picked(): void {
    this.navLayout.closePalette();
    this.returnFocus = null;
    setTimeout(() => document.getElementById('sn-main')?.focus());
  }
}
